import { Fragment, memo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { LocationIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAddress, getLongitude, getLatitude, getName } from 'conversations-message-history/attachments/operators/locationAttachmentGetters';
import { buildLocationAttachmentUrl } from 'conversations-message-history/attachments/operators/buildLocationAttachmentUrl';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LocationAttachment = ({
  locationMetadata
}) => {
  const name = getName(locationMetadata);
  const address = getAddress(locationMetadata);
  const latitude = getLatitude(locationMetadata);
  const longitude = getLongitude(locationMetadata);
  const googleMapsLink = buildLocationAttachmentUrl(locationMetadata);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlock: "100",
      marginInline: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.attachmentRendering.sharedLocation"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      justifyContent: "start",
      flexDirection: "row",
      marginBlockStart: "100",
      flexWrap: "nowrap",
      children: [/*#__PURE__*/_jsx(LocationIcon, {
        size: "400"
      }), /*#__PURE__*/_jsxs(View, {
        "data-test-id": "metadata",
        display: "inline-block",
        marginInlineStart: "200",
        children: [name && /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: name
        }), address && /*#__PURE__*/_jsx(Text, {
          marginBlock: "100",
          typography: "heading-50",
          children: address
        }), /*#__PURE__*/_jsxs(Link, {
          "data-test-id": "google-maps-link",
          href: googleMapsLink,
          target: "_blank",
          children: [latitude, ', ', longitude]
        })]
      })]
    })]
  });
};
LocationAttachment.displayName = 'LocationAttachment';
export default /*#__PURE__*/memo(LocationAttachment);